import React from 'react';
import {
  PiggyBank, Scale, PenLine, ListOrdered, Printer, ArrowLeftRight, Settings2, Send,
} from 'lucide-react';
import DashboardShortcut from './DashboardShortcut';

/**
 * BANKING panel — compact 2-column grid of banking shortcuts.
 */
export default function BankingPanel() {
  return (
    <section className="desk-panel">
      <header className="desk-panel-header">
        <span className="desk-panel-title">Banking</span>
      </header>
      <div className="desk-shortcut-grid">
        <DashboardShortcut icon={PiggyBank} label="Record Deposits" path="/banking" />
        <DashboardShortcut icon={Scale} label="Reconcile Accounts" path="/banking/reconciliation" />
        <DashboardShortcut icon={PenLine} label="Write Checks" path="/banking" />
        <DashboardShortcut icon={ListOrdered} label="Check Register" path="/banking/transactions" />
        <DashboardShortcut icon={Printer} label="Print Checks" path="/banking" />
        <DashboardShortcut icon={ArrowLeftRight} label="Bank Transactions" path="/banking/transactions" />
        <DashboardShortcut icon={Settings2} label="Bank Rules" path="/banking" />
        <DashboardShortcut icon={Send} label="Transfers" path="/banking" />
      </div>
    </section>
  );
}
